/**
 * IntroNote — a short, friendly "what you're looking at and why it matters"
 * banner shown at the top of a screen or tab. Designed so users grasp the value
 * of a view without reading the manual.
 */
export const IntroNote = ({ icon: Icon, title, children, testid }) => (
  <div
    data-testid={testid || "intro-note"}
    className="mb-6 flex items-start gap-3 rounded-md border border-ek-purple/15 bg-ek-purple/[0.04] px-4 py-3"
  >
    {Icon && (
      <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-ek-purple/10 text-ek-purple">
        <Icon size={16} />
      </span>
    )}
    <div>
      {title && <p className="text-sm font-semibold text-ek-ink">{title}</p>}
      <p className="mt-0.5 text-sm leading-relaxed text-ek-ink/60">{children}</p>
    </div>
  </div>
);
